<template>
    <div class="fixed inset-0 bg-opacity-60 bg-black flex justify-center items-center">
        <!-- Modal Header -->

        <!-- Modal Body -->
        <div
            id="modal"
            class="bg-white rounded-[12px] overflow-x-auto flex flex-col justify-between w-[515px] h-[362px]"
        >
            <!-- Modal Header -->

            <!-- Modal Body -->
            <div class="flex flex-col justify-center items-start h-full gap-[8px] w-[90%] mx-auto">
                <p class="text-[30px] font-bold">Media Guidelines</p>
                <p class="text-[14px] text-[#707575]  text-opacity-80 text-center ">
                    Duration: 30 Seconds.
                </p>
                <p class="text-[14px] text-[#707575] text-opacity-80 text-center ">
                    File types: PNG and JPEG are recommended. No BMP or TIFF files.</p>
                    <p class="text-[14px] text-[#707575]  text-opacity-80 text-center ">
                    Maximum Size : 20 MBs.
                </p>
                <p class="text-[14px] text-[#707575]  text-opacity-80 text-left ">(1920 px * 640 px), (1920 px * 1080 px).</p>
                <div class="flex content-end w-full justify-end "><button class="m-2 underline" @click="closeModal">Close</button></div>

            </div>
            <!-- Modal Footer -->
        </div>
        <!-- Modal Footer -->
    </div>
</template>

<script>
export default {
    name: "MediaGuidelinesModal",
    props: ["isMediaGuidelines"],
    methods: {
        closeModal() {
            this.$emit("close-modal"); // Emit an event to the parent to close the modal
        }
    }
};
</script>

<style></style>
